import electronService from '@services/electron/electron.service';

export function isDesktopApp() {
  return Boolean(
    typeof window.electron !== 'undefined' ||
      (typeof window.process !== 'undefined' && window.process.versions.electron),
  );
}

enum DesktopVersionWithBridgeApi {
  maj = 100,
  min = 14,
  patch = 17, // 18 in production but set here to 17 to enable autoupdate tests
}

// TODO: Refactor this
export async function isUsingNewBridgeAPI() {
  if (!isDesktopApp()) return false;
  const [maj, min, patch] = (await electronService.getElectronVersion()).split(/[-.]/);

  return (
    Number(maj) >= DesktopVersionWithBridgeApi.maj &&
    Number(min) >= DesktopVersionWithBridgeApi.min &&
    Number(patch) >= DesktopVersionWithBridgeApi.patch
  );
}

export async function isUsingNewElectron() {
  if (!isDesktopApp()) return false;
  return (await electronService.getElectronVersion()).startsWith('200.');
}
